import React,{ useEffect} from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import Settings from './Settings';
import SoundButtonPlayer from './SoundButtonPlayer';

const MYHANDWRITING_MODE= "/assets/icons/nodyslexia-mode.png";
const LEXEND_MODE = "/assets/icons/dyslexia-mode.png";

const DYSLEXIA_FRIENDLY = "Dyslexia Friendly";
const DYSLEXIA_NOTFRIENDLY = "Not Dyslexia Friendly";

function FontToggle({onFontChange, currFont}){
    // const [currFont, setCurrFont] = useState('MyHandwritten');

    const imgToUse = currFont==='MyHandwritten' ? MYHANDWRITING_MODE : LEXEND_MODE;
    const btnName = currFont=== 'MyHandwritten' ? DYSLEXIA_NOTFRIENDLY: DYSLEXIA_FRIENDLY ;

    const toggleFont=()=>{
        // console.log("toggle font triggered");//debug
        // console.log("Current font after toggle font : ",currFont);//debug
        const newFont = currFont === 'MyHandwritten' ? 'Lexend' : 'MyHandwritten';

        // setCurrFont(newFont);
        onFontChange(newFont);
    }

    useEffect(()=>{
        //console.log("useeffect triggered");//debug
        //console.log("current font after useeffect: ",currFont);//debug
        document.body.classList.remove('font-myhandwritten','font-lexend');

        /* if(currFont === 'MyHandwritten'){
            document.body.classList.add('font-myhandwritten');
        }else{
            document.body.classList.add('font-lexend');
        } */

        document.body.classList.add(currFont==='MyHandwritten' ? 'font-myhandwritten':'font-lexend');
    },[currFont]); 

    return(
        <div className="App">
            <SoundButtonPlayer onClick={toggleFont}>
                <Settings
                    settingImg={imgToUse}
                    settingName={btnName}
                />
                {/* <p>{btnName}</p> */}
            </SoundButtonPlayer>
        </div>
    );
}
export default FontToggle;